import DataItem from './data-item';

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
export default class BiBaseDataItem extends DataItem {
  constructor(evid, sessionId) {
    super({
      src: 72,
      evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime(), // cache buster
    });
  }
}
